import React from "react";
import { type RouteComponentProps, Router } from "@gatsbyjs/reach-router";
import { PageContent } from "@/features/shell/components/Page/Page";
import { UnverifiedOnly } from "@/features/auth/components/UnverifiedOnly";
import { VerificationOptions } from "./VerificationOptions";
import { AustralianDriverLicence } from "./forms/AustralianDriverLicence";
import { AustralianPassport } from "./forms/AustralianPassport";
import { MedicareCard } from "./forms/MedicareCard";
import { AustralianVisa } from "./forms/AustralianVisa";
import { NewZealandDriverLicence } from "./forms/NewZealandDriverLicence";
import { NewZealandPassport } from "./forms/NewZealandPassport";

type VerificationProps = {
  prefix?: string;
} & RouteComponentProps;

export const Verification = ({ prefix }: VerificationProps) => {
  return (
    <UnverifiedOnly>
      <PageContent>
        <Router primary={false}>
          <VerificationOptions path={`/`} default prefix={prefix} />
          <AustralianDriverLicence
            path={`/australian-drivers-licence`}
            prefix={prefix}
          />
          <AustralianPassport path={`/australian-passport`} prefix={prefix} />
          <MedicareCard path={`/medicare`} prefix={prefix} />
          <AustralianVisa path={`/australian-visa`} prefix={prefix} />
          <NewZealandDriverLicence
            path={`/nz-drivers-license`}
            prefix={prefix}
          />
          <NewZealandPassport path={`/nz-passport`} prefix={prefix} />
        </Router>
      </PageContent>
    </UnverifiedOnly>
  );
};
